import { ButtonHTMLAttributes, KeyboardEvent, MouseEvent } from 'react';
import { twMerge } from 'tailwind-merge';

export type ButtonComponentProps = {
  id?: string;
  className?: string;
  label?: string;
  href?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  onClick: (evt: MouseEvent | KeyboardEvent) => void;
};

export const getButtonProps = (
  props: ButtonComponentProps,
  btnType: 'Primary' | 'Secondary' | 'Default' | 'Link'
) => {
  const { disabled, className, id } = props;

  const disabledClass = disabled ? `${btnType}Button-disabled` : '';
  const additionalClass = className || '';

  const finalClass = twMerge(
    `${btnType}Button`,
    disabledClass,
    additionalClass
  );
  const finalId = id.trim();

  const baseProps: ButtonHTMLAttributes<HTMLButtonElement | HTMLAnchorElement> =
    {
      className: finalClass,
    };

  if (finalId) {
    baseProps.id = finalId;
  }

  return baseProps;
};
